import { compose, lifecycle } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { fetchSeriesAllocation } from 'reducers/series/actions';
import { fetchDashboard } from 'reducers/dashboard/actions';
import { seriesListIds } from 'reducers/series/selectors';
import {
  dashboardLoading,
  seriesAllocationLoading,
} from 'reducers/loading/selectors';
import { stale as dashboardStale } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { chunk, each, map } from 'lodash';

export function componentDidMount() {
  this.props.fetchSeriesAllocation();
  this.props.fetchDashboard();
}

const mapStateToProps = combineSelectors({
  seriesListIds,
  dashboardStale,
  dashboardLoading,
  seriesAllocationLoading,
});

export const seriesRows = ({ seriesListIds }) => {
  let width = document.documentElement.clientWidth;
  let numberOfColumns = width > 1340 ? 4 : 3;
  return chunk(seriesListIds, numberOfColumns);
};

export const orderList = ({ seriesRows }) =>
  map(seriesRows, (elements, index) => [index * 2, elements]);

export const quotaDetailOrder = ({
  hasQuotaDetail,
  seriesRows,
  selectedSeriesId,
}) => {
  let quotaDetailOrder = 0;
  if (hasQuotaDetail) {
    each(seriesRows, (row, i) => {
      if (row.includes(selectedSeriesId)) {
        quotaDetailOrder = i * 2 + 1;
      }
    });
  }
  return quotaDetailOrder;
};

export const isLoading = ({ dashboardLoading, seriesAllocationLoading }) =>
  dashboardLoading || seriesAllocationLoading;

export default compose(
  connect(
    mapStateToProps,
    { fetchSeriesAllocation, fetchDashboard },
  ),
  lifecycle({ componentDidMount }),
  addProps({ seriesRows }),
  addProps({ orderList, quotaDetailOrder, isLoading }),
);
